import { PARENT } from "@/lib/offline/rules";

export const segs = (p) => p.split("/").filter(Boolean);

export const keyOf = (path, params) => {
  const q = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== "") q.append(k, v); });
  q.sort();
  const s = q.toString();
  return s ? `${path}?${s}` : path;
};

export const splitUrl = (url, params) => {
  const [path, qs] = url.split("?");
  const all = { ...Object.fromEntries(new URLSearchParams(qs || "")), ...(params || {}) };
  return { path: path.replace(/\/+$/, "") || "/", key: keyOf(path.replace(/\/+$/, "") || "/", all), params: all };
};

export const walk = (node, fn, parent = null, k = null) => {
  if (Array.isArray(node)) { for (let i = node.length - 1; i >= 0; i -= 1) walk(node[i], fn, node, i); return; }
  if (node && typeof node === "object" && !(node instanceof Blob)) {
    fn(node, parent, k);
    Object.entries(node).forEach(([ck, v]) => { if (v && typeof v === "object") walk(v, fn, node, ck); });
  }
};

export const findById = (r, id) => {
  let hit = null;
  Object.values(r).forEach((v) => walk(v, (o) => { if (!hit && o.id === id) hit = o; }));
  return hit;
};

const blank = (v, k) => {
  if (["role", "tier", "universe_id", "story", "draft", "locked"].includes(k)) return k === "locked" ? false : v;
  if (Array.isArray(v)) return [];
  if (typeof v === "string") return "";
  if (typeof v === "number") return 0;
  if (typeof v === "boolean") return false;
  if (v && typeof v === "object") return k === "attributes" ? {} : undefined;
  return v;
};

export const synth = (template, path, body, tmp, uid) => {
  const s = segs(path);
  const out = {};
  Object.entries(template || {}).forEach(([k, v]) => { const b = blank(v, k); if (b !== undefined) out[k] = b; });
  const now = new Date().toISOString();
  return { ...out, [PARENT[s[0]] || `${s[0]}_id`]: s[1], universe_id: uid, ...body, id: tmp, created_at: now, updated_at: now, _local: true };
};

export const replaceIds = (v, map) => {
  if (typeof v === "string") return map[v] || v;
  if (Array.isArray(v)) return v.map((x) => replaceIds(x, map));
  if (v && typeof v === "object") return Object.fromEntries(Object.entries(v).map(([k, x]) => [replaceIds(k, map), replaceIds(x, map)]));
  return v;
};

export const replaceUrl = (url, map) => url.split("/").map((p) => map[p] || p).join("/");
